import React from 'react'
import { createRoot } from 'react-dom/client'
import './config/firebase'
import './index.scss'
import App from './App'
import 'semantic-ui-css/semantic.min.css'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import store from './store'
import { JoyrideProvider } from './components/Joyride'
import { ErrorBoundaryProvider } from './components/ErrorBoundary'
import { applyTheme, getStoredTheme } from './utils/theme'

// Paint the last-known theme before first render; Firestore profile reconciles later.
applyTheme(getStoredTheme())

const container = document.getElementById('root')!
const root = createRoot(container)

root.render(
  // @ts-ignore
  <Provider store={store}>
    <ErrorBoundaryProvider>
      <JoyrideProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </JoyrideProvider>
    </ErrorBoundaryProvider>
  </Provider>,
)
